export var dataHooks = {
  content: 'counter-badge-content'
};
export var SIZES = {
  small: 'small',
  medium: 'medium'
};